<template>
	<TIcon>
		<path
			d="m17.03 12.53-7.5 7.5a.751.751 0 0 1-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 1 1 1.06-1.06l7.5 7.5a.75.75 0 0 1 0 1.06Z"
		/>
	</TIcon>
</template>

<script setup lang="ts">
import TIcon from '@/app/common/TIcon.vue'
</script>
